const PT_BR_LOCALE = 'pt-BR';
const FRACTION_OPTIONS: Intl.NumberFormatOptions = {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1
};

export const scoreToTen = (value: number | null | undefined): number | null => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return null;
  }
  return Number(value) / 10;
};

export const formatScoreOutOfTen = (
  value: number | null | undefined,
  fallback = '-'
): string => {
  const ten = scoreToTen(value);

  if (ten === null) {
    return fallback;
  }
  return `${ten.toLocaleString(PT_BR_LOCALE, FRACTION_OPTIONS)} / 10`;
};
